import PrivacyText from "../components/PrivacyText";

export default function Privacy() {
    return (
        <div style={{display: 'flex', justifyContent: 'center', padding: 24}}>
            <div style={{width: '100%', maxWidth: 900}}>
                <PrivacyText />
            </div>
        </div>
    )
}
